import { createReducer, on } from '@ngrx/store';
import { DotCMSConfigurationParams, DotCMSLanguageItem } from 'dotcms/src/lib/models';

import {
  allowDotCmsApiCall,
  loadDotCmsAvailableLanguagesSuccess,
  loadDotCmsConfiguration,
  loadDotCmsConfigurationSuccess,
  restrictDotCmsApiCall,
  setDotCmsPersona,
  setDotCmsSelectedLanguage,
} from './dotcms-configuration.action';

export interface DotCmsConfigurationState {
  apiConfiguration: DotCMSConfigurationParams;
  language: DotCMSLanguageItem;
  fallbackLanguages: DotCMSLanguageItem[];
  canMakeApiCall: boolean;
  personaId?: string;
}

export const initialState: DotCmsConfigurationState = {
  apiConfiguration: undefined,
  language: undefined,
  fallbackLanguages: undefined,
  canMakeApiCall: false,
  personaId: undefined,
};

export const dotCmsConfigurationReducer = createReducer(
  initialState,
  on(
    loadDotCmsConfigurationSuccess,
    (state, action): DotCmsConfigurationState => ({
      ...state,
      apiConfiguration: action.payload.apiConfiguration,
    })
  ),
  on(
    loadDotCmsAvailableLanguagesSuccess,
    (state, action): DotCmsConfigurationState => ({
      ...state,
      fallbackLanguages: action.payload.languages,
    })
  ),
  on(
    setDotCmsSelectedLanguage,
    (state, action): DotCmsConfigurationState => ({
      ...state,
      language: action.payload.language,
    })
  ),
  on(
    setDotCmsPersona,
    (state, action): DotCmsConfigurationState => ({ ...state, personaId: action.payload.personaId })
  ),
  on(
    loadDotCmsConfiguration,
    (state): DotCmsConfigurationState => ({
      ...state,
      canMakeApiCall: false,
    })
  ),
  on(
    allowDotCmsApiCall,
    (state): DotCmsConfigurationState => ({
      ...state,
      canMakeApiCall: true,
    })
  ),
  on(
    restrictDotCmsApiCall,
    (state): DotCmsConfigurationState => ({
      ...state,
      canMakeApiCall: false,
    })
  )
);
